export default "__VITE_ASSET__DdE8VoUp__"